import { jsx as _jsx } from "react/jsx-runtime";
export default function HeaderContainer(props) {
    return (_jsx("header", { className: `fixed top-0 z-30 w-full text-day-mode-text-primary transition sm:top-4 ${props.isScrolled ? 'sm:-translate-y-4' : 'sm:absolute'}`, children: props.children }));
}
